import React, { ComponentProps, FC, useRef } from 'react'

import clsx from 'clsx'
import { useHoverDirty } from 'react-use'
import styled, { css } from 'styled-components'

const Hatching = styled.div<{ isHovering: boolean; size: 's' | 'm' }>`
  ${({ isHovering }) =>
    isHovering
      ? css`
          background-image: linear-gradient(
            -45deg,
            #eff1f4 25%,
            #c6c6c6 25%,
            #c6c6c6 50%,
            #eff1f4 50%,
            #eff1f4 75%,
            #c6c6c6 75%,
            #c6c6c6
          );
        `
      : css`
          background-image: linear-gradient(
            -45deg,
            #eff1f4 25%,
            #dbdbde 25%,
            #dbdbde 50%,
            #eff1f4 50%,
            #eff1f4 75%,
            #dbdbde 75%,
            #dbdbde
          );
        `}
  background-size: 0.5rem 0.5rem;
  height: ${({ size }) => (size === 's' ? '2.57rem' : '3.43rem')};
  border-radius: 4px;
  outline: none;
`

type ButtonProps = ComponentProps<'button'>
type Props = ButtonProps & {
  size?: 's' | 'm'
}

export const ShadedButton: FC<Props> = ({ className, children, size = 's', ...otherProps }) => {
  const ref = useRef(null)
  const isHovering = useHoverDirty(ref)

  return (
    <button type="button" className={`tw-outline-0 ${className}`} {...otherProps}>
      <Hatching
        isHovering={isHovering}
        className={clsx(
          'tw-centering tw-border tw-border-border-primary',
          isHovering ? 'tw-text-standardText-primary' : 'tw-text-standardText-secondary'
        )}
        ref={ref}
        size={size}
      >
        {children}
      </Hatching>
    </button>
  )
}
